import i18n from 'shared/lib/i18n';

export const normalizeValues = (data) => {
  let normalizedData = { ...data };
  if (data.unitLine === null) {
    normalizedData = { ...normalizedData, unitLine: '' };
  }
  if (data.floor === null) {
    normalizedData = { ...normalizedData, floor: '' };
  }
  return normalizedData;
};

export const checkValidStructure = (data) => {
  if (!data?.length) return [i18n.t('errors.noData')];
  const errors = [];
  data.forEach(({ floor, name }, i) => {
    const currentRow = i + 1;
    if (!floor && !name) {
      errors.push(i18n.t('errors.noEmptyRow', { currentRow }));
    } else if (!floor) {
      errors.push(i18n.t('errors.noEmptyFloor', { currentRow }));
    } else if (!name) {
      errors.push(i18n.t('errors.noEmptyName', { currentRow }));
    }
  });
  return errors;
};

export const srtSeparateToArray = (nameText) => {
  if (!nameText) return null;
  const names = nameText.split('\n').join(',').split(',');
  const formattedNames = names
    .filter((name) => !!name.trim())
    .map((name) => name.trim());
  return formattedNames;
};
